import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgTimer = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.692 2.75a.75.75 0 0 1 .75-.75h4.27a.75.75 0 0 1 0 1.5h-1.385v1.379a8.578 8.578 0 1 1-1.5 0V3.5H9.442a.75.75 0 0 1-.75-.75m2.885 3.596a7.077 7.077 0 1 0 0 14.154 7.077 7.077 0 0 0 0-14.154M8.992 9.977a.75.75 0 0 1 1.05.15l2.135 2.846a.75.75 0 0 1-1.2.9l-2.135-2.846a.75.75 0 0 1 .15-1.05m10.23-5.623a.75.75 0 0 0-1.06 1.061l1.423 1.423a.75.75 0 1 0 1.06-1.06z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgTimer;
